import axios from "axios";
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { BsArrowLeft } from "react-icons/bs";
import { FaEye, FaSearch } from "react-icons/fa";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { Link } from "react-router-dom";
import Loader from "../../../Components/Global/Loader";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";

import { useAuth } from "../../../Context/AuthContext";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";

function RentCollectionManagerProfile({ allowedRoles }) {
  useAuthentication(allowedRoles)
  const { unitCount, designation } = useAuth();
  const [loading, setLoading] = useState();
  const [tenantData, setTenantData] = useState([]);
  const [buildinglist, setBuildinglist] = useState();
  const [unitlist, setUnitlist] = useState("");
  const [buildingDropdown, setBuildingDropdown] = useState("");
  const [unitDropdown, setUnitDropdown] = useState("");
  const [record, setRecord] = useState(5);
  const [pages, setPages] = useState(1);
  const [pageNumberlimit, setPageNumberlimit] = useState(1);
  const [maxPageNumberlimit, setMaxPageNumberlimit] = useState(4);
  const [minPageNumberlimit, setMinPageNumberlimit] = useState(0);
  const [totallength, setTotallength] = useState([]);
  const [Count, setCount] = useState();
  const [tenantSearch, setSearchTenant] = useState("");
  const [lgShow, setLgShow] = useState(false);
  const [isKeyPress, setisKeyPress] = useState(false);
  // api api from global hook 

  const { axiosFetch} = useAxiosFetch();

  useEffect(() => {
    SearchListFunc();
  }, []);

  useEffect(() => {
    SearchTenant();
  }, [buildingDropdown, unitDropdown]);

  useEffect(() => {
    TenantDataList();
    setBuildingDropdown("");
  }, [record, pages]);

  useEffect(() => {
    if (!tenantSearch == "") {
      SearchTenant();
    } else {
      TenantDataList();
    }
  }, [tenantSearch, record, pages]);

  useEffect(() => {
    UnitListFunc();
  }, [buildingDropdown]);

  const SearchValue = (e) => {
    const { value, name } = e.target;
    if (name === "buildingDropdown") {
      setBuildingDropdown(value);
    } else if (name === "unitDropdown") {
      setUnitDropdown(value);
    }
  };

  const TenantDataList = () => {
    setLoading(true);
    axiosFetch({
      axiosInstance: axios,
      method: 'post',
      url:`/tenant/list`,
      
      requestConfig: {  pages, record },


  })
      .then((response) => {
        if (response?.data?.result?.count >= 0) {
          setCount(response?.data?.result?.count);
          setTenantData(response.data.result.rows);
        }
        if (response?.data?.totallength >= 0) {
          let pageNo = response.data.totallength;
          let pagelist = [];

          for (let i = 0; i < pageNo; i++) {
            pagelist.push(i + 1);
          }
          setTotallength(pagelist);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const SearchTenant = () => {
    !isKeyPress && setPages(1);

    axios
      .post(`/search`, {
        tenant_name: tenantSearch,
        record: record,
        page: isKeyPress ? pages : 1,
        unit_id: unitDropdown,
        building_id: buildingDropdown,
      })
      .then((res) => {
        if (res?.data?.result?.count >= 0) {
          setTenantData(res?.data?.result?.rows);
          setCount(res?.data?.result?.count);
        }

        if (res?.data?.totallength >= 0) {
          let pageNo = res?.data?.totallength;
          let pagelist = [];

          for (let i = 0; i < pageNo; i++) {
            pagelist.push(i + 1);
          }
          setTotallength(pagelist);
        }
      });
  };
  const SearchListFunc = () => {
    setLoading(true);
    axiosFetch({
      axiosInstance: axios,
      method: 'GET',
      url:`/buildingDropdown`


  })
      .then((res) => {
        if (res?.data) {
          setBuildinglist(res?.data?.building);
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  const UnitListFunc = () => {
    setLoading(true);
    
    axiosFetch({
      axiosInstance: axios,
      method: 'post',
      url:`/UnitDropdown`,
      
      requestConfig: { buildingDropdown },


  })
      .then((res) => {
        if (res?.data) {
          setUnitlist(res?.data?.Units);
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const PagesFunc = (val) => {
    setisKeyPress(true);
    setPages(val);
  };
  function handleNextbtn() {
    setisKeyPress(true);
    setPages(pages + 1);
    if (pages + 1 > maxPageNumberlimit) {
      setMaxPageNumberlimit(maxPageNumberlimit + pageNumberlimit);
      setMinPageNumberlimit(minPageNumberlimit + pageNumberlimit);
    }
  }

  function handlePrevbtn() {
    setisKeyPress(true);
    setPages(pages - 1);
    if ((pages - 1) % pageNumberlimit == 0) {
      setMaxPageNumberlimit(maxPageNumberlimit - pageNumberlimit);
      setMinPageNumberlimit(minPageNumberlimit - pageNumberlimit);
    }
  }

  const PageShowFunc = totallength?.map((items, i) => {
    if (items) {
      return (
        <li key={i}>
          <button
            value={items}
            name="pages"
            className={pages == items ? "active" : null}
            onClick={(e) => PagesFunc(items)}
          >
            {items}
          </button>
        </li>
      );
    } else {
      return null;
    }
  });

  return (
    <>
      <DashboardLayouts>
        {loading && <Loader />}
        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="col-xl-2 d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
            <Link
              to={
                designation === "Owner" || designation === "Partner"
                  ? "/dashboard"
                  : `/${designation}dashboard`.toLowerCase()
              }
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Dashboard</h3>
            </Link>
          </div>
          <Modal
            size="lg"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            className="empty-list-modal-popup"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="text-center">
              <b className="text-m block text-center p-4 rounded border border-white text-danger">
                Please add atleast one unit under building
              </b>
              <Link to="/viewbuilding" className="btn btn-outline-primary mt-1">
                Building List
              </Link>
            </Modal.Body>
          </Modal>

        </div>

        <div className="list-data">
          <div className="d-flex justify-content-between">
            <h1 className="heading-text mb-4">All Tenant</h1>
            <div className="form search-bar1">
              <input
                type="search"
                className="form-control search-new"
                placeholder="search tenant name"
                aria-label="search"
                aria-describedby="search"
                name="tenantSearch"
                onKeyDown={(e) => setisKeyPress(false)}
                onChange={(e) => setSearchTenant(e.target.value.trimStart())}
              />
              <button
                className="search-btn fa-solid fa-magnifying-glass"
                type="submit"
                disabled={tenantSearch.trimStart() == ""}
                onClick={(e) => SearchTenant(e)}
              >
                <FaSearch className="m-0  " color="#bebebe" />
              </button>
            </div>
          </div>

          {/* --- Data filter --- */}
          <div className="data-filters d-flex justify-content-between align-items-center mb-4 mb-xxl-4">
            <div className="page-records d-block d-xxl-flex align-items-center">
              <div className="d-flex align-items-center">
                <form className="number">
                  <select
                    className="number-box"
                    value={record}
                    name="record"
                    onChange={(event) => {
                      setRecord(event.target.value);
                      setPages(1);
                    }}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                  </select>
                </form>
                <h3 className="mb-0 ms-2 d-none d-sm-block">
                  Records Per Page
                </h3>
              </div>
            </div>
            <div className="filter">
              <select
                name="buildingDropdown"
                value={buildingDropdown}
                onChange={(e) => SearchValue(e)}
                id=""
                className="all-task-btn me-0"
              >
                <option value="">Choose Building</option>
                {buildinglist?.map((list, i) => {
                  return (
                    <option key={i} value={list.id}>
                      {list.buliding_name}
                    </option>
                  );
                })}
              </select>
              <select
                name="unitDropdown"
                id="unitDropdown"
                value={unitDropdown}
                onChange={(e) => SearchValue(e)}
                className="all-task-btn"
              >
                <option value="">Choose Unit</option>
                {unitlist?.length > 0 ? (
                  unitlist?.map((list, i) => {
                    return (
                      <option key={i} value={list.id}>
                        {list.unit_name}
                      </option>
                    );
                  })
                ) : (
                  <option value="">No Unit Name</option>
                )}
              </select>
            </div>
          </div>
        </div>

        <div className="w-100 table-content">
          <div className="w-100 overflow-auto">
            <table className="w-100">
              <thead>
                <tr>
                  <th>Sl No</th>
                  <th>Name</th>
                  <th className="text-center">Tenant ID</th>
                  <th className="text-center">Building Name</th>
                  <th className="text-center">Unit</th>

                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody className="t-data">
                {tenantData?.length > 0 ? (
                  tenantData?.map((list, index) => {
                    return (
                      <tr key={index}>
                        <td className="text-center">
                          {" "}
                          {pages > 1
                            ? record * (pages - 1) + index + 1
                            : index + 1}
                        </td>

                        <td>
                          {list.first_name + " " + list.last_name}

                        </td>

                        <td className="text-center">{list.tenant_code}</td>
                        <td className="text-center">{list.building_name}</td>
                        <td className="text-center">{list.unit_name}</td>


                        <td className="text-center">
                          <ul className="table-icon d-flex justify-content-center">
                            <li>
                              <Link to={`/manager/rent-collection/${list.id}`}>
                                <FaEye className="view-icon" color="black" />
                              </Link>
                            </li>

                          </ul>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No tenant list
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {Count > 5 && totallength.length > 1 ? (
              <div className="table_bottom d-flex align-items-center justify-content-end mt-5 pageNumbers">
                <button
                  onClick={handlePrevbtn}
                  disabled={pages == 1 ? true : false}
                >
                  <GrFormPrevious className="pagebutton" color="#bebebe" />
                </button>
                <ul className="d-flex">{PageShowFunc}</ul>
                <button
                  onClick={handleNextbtn}
                  disabled={pages == PageShowFunc.length ? true : false}
                >
                  <GrFormNext className="pagebutton" color="#bebebe" />
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </DashboardLayouts>
    </>
  );
}

export default RentCollectionManagerProfile;
